import { identify, makeRequest, Service } from 'utils/http';

export async function resendInvitationAPI(userId: string) {
  return makeRequest(Service.resendInvite({ userId }, await identify()));
}
